import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/1anabLogo.png'


const _hoisted_1 = {
  id: "footer",
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-1"
}
const _hoisted_4 = {
  class: "flex justify-center align-center mr-10",
  id: "footerLinks"
}
const _hoisted_5 = {
  href: "https://1anab.de/impressum/",
  target: "_blank"
}
const _hoisted_6 = {
  href: "https://1anab.de/datenschutz/",
  target: "_blank"
}

import { useGlobalStore } from "@/stores/GlobalStore";
import router from "@/router";
import {computed} from "vue";
import {PermissionService} from "@/utilities/services/PermissionService";


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const showChangelog = computed(()=>{
  const permissionService = new PermissionService();
  return router.currentRoute.value.name !== 'Login'
      && router.currentRoute.value.name !== 'Logout'
      && permissionService.userHasPermission("Setting.Navigation.Show");
});

const globalStore = useGlobalStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(globalStore).currentItems !== 0 && _unref(globalStore).allItems !== 0 && _unref(globalStore).currentItems !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_unref(globalStore).currentItems), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('footer.of')) + " " + _toDisplayString(_unref(globalStore).allItems) + " " + _toDisplayString(_ctx.$t('footer.results')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " ")),
    _createElementVNode("div", _hoisted_4, [
      (showChangelog.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "flex",
            to: "/changelog"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("footer.changelog")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('footer.imprint')), 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('footer.privacy')), 1)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "anabLogo mr-10" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "circle mr-4" }, [
      _createElementVNode("span", { class: "icon-helpdesk" })
    ], -1))
  ]))
}
}

})